import { createFileRoute } from "@tanstack/react-router";
import { InvitationsPage } from "@/components/pages/InvitationsPage";

export const Route = createFileRoute("/invitations/")({
  component: InvitationsPage,
});
